import { useMemo } from 'react';

import { createFetcher } from '../api/fetcher';
import { useAppConfig, useAuth } from '../context';
import { Fetcher } from '../models';

export const useSecurePortalFetcher = (): Fetcher => {
  const { securePortalApiUrl } = useAppConfig();
  const { getJwtToken } = useAuth();

  return useMemo(
    () =>
      createFetcher({
        baseUrl: securePortalApiUrl,
        hooks: {
          before: async (request) => {
            const token = await getJwtToken();
            request.headers.set('Authorization', `Bearer ${token}`);
          },
        },
      }),
    [securePortalApiUrl, getJwtToken]
  );
};
